<template>
    <div class="module-bg-blue" :style="{backgroundImage: 'url('+ BgBlueImg +')',...blueStype}">
      <slot></slot>
    </div>
</template>
<script>
import BgBlue from '@/assets/product/bg-blue.png'
export default {
  props: {
    blueStype: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    BgBlue
  },
   data() {
      return {
        BgBlueImg: BgBlue,
      }
   },
   created(){
   },
   computed:{
   },
   methods:{
   },
}
</script>
<style lang="less" scoped>
.module-bg-blue {
  width: 100%;
  min-width: 1200px;
  height: 810px;
  background-repeat: no-repeat;
  background-size: auto 100%;
  background-position:top center;
}
</style>
